module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_pão.11fd94e4.png";